// vue-meta 2 の置き換え。
// vue-meta には Vue 3 対応の安定版が無く、このアプリが使っているのは
// コンポーネントの metaInfo オプションの title / titleTemplate / bodyAttrs.class だけなので、
// その 3 つを同じ意味で解釈する最小限の実装にしている。
//
// - title: 最も深い（同じ深さなら後から作られた）コンポーネントの値を使う
// - titleTemplate: 同じ規則で選ぶ。関数なら title を渡して呼び、文字列なら %s を置き換える
// - bodyAttrs.class: 表示中の全コンポーネントの和集合を <body> に付ける。
//   このプラグインが付けたクラスだけを外すので、他の経路で付いたクラスには触らない
import { nextTick } from 'vue'

const resolve = (vm) => {
  const metaInfo = vm.$options.metaInfo
  return (typeof metaInfo === 'function' ? metaInfo.call(vm) : metaInfo) || {}
}

const depthOf = (vm) => {
  let depth = 0
  for (let p = vm.$parent; p; p = p.$parent) depth++
  return depth
}

const toClassList = (value) => {
  if (!value) return []
  if (Array.isArray(value)) return value.flatMap(toClassList)
  if (typeof value === 'string') return value.split(/\s+/).filter(Boolean)
  return Object.keys(value).filter((key) => value[key])
}

export default {
  install (app) {
    const entries = new Map() // vm => { depth, order }
    let sequence = 0
    let scheduled = false
    let appliedBodyClasses = []

    const pick = (metas, key) => {
      let found
      metas.forEach((meta) => { if (meta[key] !== undefined) found = meta[key] })
      return found
    }

    const apply = () => {
      scheduled = false
      const metas = [...entries.entries()]
        .sort(([, a], [, b]) => a.depth - b.depth || a.order - b.order)
        .map(([vm]) => resolve(vm))

      const title = pick(metas, 'title')
      const template = pick(metas, 'titleTemplate')
      if (title !== undefined || template !== undefined) {
        const chunk = title || ''
        document.title = typeof template === 'function'
          ? template(chunk)
          : (template ? template.replace(/%s/g, chunk) : chunk)
      }

      const classes = [...new Set(metas.flatMap((meta) => toClassList(meta.bodyAttrs && meta.bodyAttrs.class)))]
      appliedBodyClasses.filter((c) => !classes.includes(c)).forEach((c) => document.body.classList.remove(c))
      classes.forEach((c) => document.body.classList.add(c))
      appliedBodyClasses = classes
    }

    const schedule = () => {
      if (scheduled) return
      scheduled = true
      nextTick(apply)
    }

    app.mixin({
      created () {
        if (!this.$options.metaInfo) return
        entries.set(this, { depth: depthOf(this), order: sequence++ })
        this.$watch(() => resolve(this), schedule, { deep: true })
        schedule()
      },
      beforeUnmount () {
        if (!entries.delete(this)) return
        schedule()
      }
    })
  }
}
